import { AuthMeResponse } from 'src/app/core/auth-me/auth-me.models';

/** Matches legacy: (audit_trail_view OR settings_view) AND audit_trail package feature. */
export function canViewAuditTrail(authMe: AuthMeResponse | null | undefined): boolean {
  const c = authMe?.capabilities;
  if (!c?.packageFeatures?.auditTrail) {
    return false;
  }
  return !!(c.appConfig?.canViewAuditTrail || c.appConfig?.canViewSettings);
}
